import { View, StyleSheet, Platform, TextInput, Pressable } from 'react-native'
import NumericInput from 'react-native-numeric-input'
import { useTheme } from '@react-navigation/native';
import React from 'react'
import CustomInput from '../CustomInput';

const CustomNumericInput = ({ value, setValue, min, max, type = "PRIMARY", editable = true }) => {
  const { colors } = useTheme();
  const styles = makeStyles(colors);

  if (Platform.OS === 'web') {
    // Render a native HTML input element with type="number" for web
    return (
      <CustomInput
        value={value.toString()}
        editable={editable}
        selectall={true}
        setValue={value => setValue(value)}
        keyboardType="numeric"
        type='SM_MYPROFILE'
      />
    );
  } else {
    // Render a TextInput component with keyboardType="numeric" for mobile
    return (
      <View style={[
        styles.container,
        styles[`container_${type}`],
      ]}>
        <NumericInput
          initValue={value}
          value={value}
          editable={editable}
          totalWidth={145}
          totalHeight={46}
          iconSize={15}
          rounded
          type='up-down'
          minValue={min}
          textColor={colors.text_primary}
          maxValue={max}
          onChange={value => setValue(value)}
          containerStyle={styles.NumericInputContainer}
          inputStyle={styles.NumericInput}
          iconStyle={styles.IconStyle}
          style={[
            styles.input,
            styles[`input_${type}`],
          ]}
        />
      </View>
    )
  };
}

const makeStyles = (colors) => StyleSheet.create({

  container: {
    width: '100%',
    marginVertical: 5,
  },

  input: {
    fontSize: 16,
    fontFamily: 'Roboto-Medium',
    color: colors.text_primary,
  },

  container_SM_MYPROFILE: {
    height: '100%',
    backgroundColor: 'black',
  },

  input_SM_MYPROFILE: {
    fontSize: 16,
    color: colors.text_primary,
    paddingHorizontal: 0,
    padding: 5,
  },

  container_MYPROFILE: {
    flex: 1,
    backgroundColor: colors.background_dropdown,
    borderRadius: 10,
    borderWidth: 2,
    width: '94%',
    height: '100%',
  },

  input_MYPROFILE: {
    flex: 1,
    fontSize: 16,
    color: colors.text_primary,
  },

  container_FULL: {
    marginVertical: 5,
  },

  container_PRIMARY: {
    flex: 1,
    backgroundColor: colors.background_dropdown,
    padding: 15,
  },

  input_PRIMARY: {
    flex: 1,
    fontSize: 8,
    color: colors.text_input,
  },

  NumericInputContainer: {
    height: '100%',
    borderWidth: 2,
    borderRadius: 10,
    backgroundColor: colors.white_or_transparent,
    borderColor: colors.border_card,
  },
});

export default CustomNumericInput;